export { FaqPage as default } from '@/components/enpages/Ir/faq'
